import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme();

const styles = {
    paper: {
        // height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        // marginTop: theme.spacing(2),
        '& form': {
            marginTop: theme.spacing(1),
        } /** exemplo de child selector */,
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(2),
    },
    img: {
        width: '250px',
        [theme.breakpoints.down('xs')]: {
            width: '200px',
        },
    },
    error: {
        marginBottom: '5px',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    wrapper: {
        position: 'relative',
    },
};

export default styles;
